/**
 * ProgramGrid Component
 * Responsive grid container for program cards
 */

import React from 'react';
import { FaPlus, FaFolderOpen } from 'react-icons/fa';
import { ClipLoader } from 'react-spinners';
import ProgramCard from '../ProgramCard';
import styles from './ProgramGrid.module.css';

const ProgramGrid = ({
  programs = [],
  onProgramSelect,
  clubId,
  canManage = false,
  isClubManager = false,
  userClubRole = null,
  isLoading = false,
  onEditProgram,
  onDeleteProgram,
  onManageProgram,
  onAddProgram,
  onJoinClubRequired
}) => {
  // Loading state
  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <ClipLoader color="#A4EB3F" loading={true} size={40} />
        <p>Loading programs...</p>
      </div>
    );
  }

  // Empty state
  if (programs.length === 0) {
    return (
      <div className={styles.emptyContainer}>
        <FaFolderOpen className={styles.emptyIcon} />
        <h3>No programs found</h3>
        <p>
          {canManage 
            ? "Get started by creating your first program!" 
            : "Check back later for available programs."}
        </p>
        {canManage && onAddProgram && (
          <button className={styles.addButton} onClick={onAddProgram}>
            <FaPlus /> Create Program
          </button>
        )}
      </div>
    );
  }

  return (
    <div className={styles.gridContainer}>
      <div className={styles.grid}>
        {programs.map(program => (
          <ProgramCard
            key={program._id}
            program={program}
            clubId={clubId}
            onClick={() => onProgramSelect(program)}
            canManage={canManage}
            isClubManager={isClubManager}
            userClubRole={userClubRole}
            onEdit={onEditProgram}
            onDelete={onDeleteProgram}
            onManage={onManageProgram}
            onJoinClubRequired={onJoinClubRequired}
          />
        ))}
      </div>

      {/* Results info */}
      <div className={styles.resultsInfo}>
        Showing {programs.length} program{programs.length !== 1 ? 's' : ''}
      </div>
    </div>
  );
};

export default ProgramGrid;









